<template>
  <CourseSelectionWtxh v-if="siteId == 116" />
  <CourseSelectionDefault v-else />
</template>

<script>
import CourseSelectionDefault from "./courseSelectionDefault.vue";
import CourseSelectionWtxh from "./courseSelectionWtxh.vue";

export default {
  name: "CourseSelectionContainer",
  components: {
    CourseSelectionDefault,
    CourseSelectionWtxh,
  },
  data() {
    return {
      siteId: null,
    };
  },
  created() {
    let info = localStorage.getItem("siteInfo");
    if (info) {
      this.siteId = JSON.parse(info).id;
    }
  },
};
</script>
